<!-- Re-Run pipeline -->
<!-- <div [hidden]="!loading" class="loader-main">

</div>
<div [hidden]="loading" class="router-output">
  <router-outlet></router-outlet>  </div> -->
@if (noInternetConnection()) {
<div style="text-align: center" class="no-internet">
  <img src="assets/images/no-wifi-2.png" alt="Wifi Disconnected" />
  <h4>No Internet connection!</h4>
</div>
}
<router-outlet></router-outlet>
